
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/photo-recolor",
      function () {
        return require("private-next-pages/photo-recolor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/photo-recolor"])
      });
    }
  